import { isDefined } from "@clipboard-health/util-ts";

import { getAppUrl } from "./getAppUrl";

export const getLoginUrl = (params: { email: string; redirectUri?: string }): string => {
  const { email, redirectUri } = params;
  const appDomain = getAppUrl();

  try {
    const loginUrl = new URL(`${appDomain}/welcome/login/linkVerify`);
    loginUrl.searchParams.set("email", email);
    if (isDefined(redirectUri)) {
      loginUrl.searchParams.set("redirectUri", redirectUri);
    }

    return loginUrl.toString();
  } catch (error) {
    throw new Error(
      `Problem creating login URL for appDomain: ${appDomain}. Original error: ${String(error)}`
    );
  }
};
